import type React from 'react'

import PageTitle from '@frontend/features/pages/components/PageTitle'
import ProductList from '@frontend/features/product-list/ProductList'
import { usePostBySlug } from '@frontend/libs/hooks/usePost'
import { cn } from '@nextui-org/react'
import ErrorBoundary from '@shared/ErrorBoundary'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { data: post, error } = usePostBySlug('special-price')

  if (error) {
    toast.error(error?.message || 'Failed to fetch checkout page')
    showBoundary(error)
  }

  if (post) {
    document.title = post.meta.title

    const styleTag = document.getElementById('core-block-supports-inline-css')

    if (styleTag) {
      styleTag.innerHTML = post.styles
    } else {
      const style = document.createElement('style')
      style.id = 'core-block-supports-inline-css'
      document.head.appendChild(style)
      style.innerHTML = post.styles
    }
  }

  return (
    <div
      className={cn({
        'mb-12': !post?.options.showTitle,
        'my-12': post?.options.showTitle,
      })}
    >
      {post?.options.showTitle && (
        <PageTitle title={post?.title || 'Special Price'} />
      )}
      <ProductList
        showCategoryFilter={false}
        showCollectionFilter={false}
        type="special-price"
      />
    </div>
  )
}

export function SpecialPrice(): null | React.JSX.Element {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default SpecialPrice
